import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkdonationV1Component } from './bulkdonation-v1.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [BulkdonationV1Component],
  exports: [BulkdonationV1Component],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    MatRippleModule,
    MatButtonModule
  ]
})
export class BulkdonationV1Module { }
